<template>
    <div class="mini-calendar">
        <MiniCalenderFilters />
        <MiniCalenderEvents />
    </div>
</template>

<script>
import MiniCalenderFilters from './mini-calendar-filters.vue'
import MiniCalenderEvents from './mini-calendar-events.vue'

import { getEvents, getCategories, getFilteredEvents } from './../api'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { generateStaticDay } from './../utils/util';
import { DATE_FORMAT } from './../utils/config';

export default {
  name: 'HomePage',
  components: {
    MiniCalenderFilters,
    MiniCalenderEvents
  },
  created() {
    const param = this.$route.query;
    this.LoadEvents(param);
    this.$watch(
      () => this.$route.query,
      (toParams) => {
        this.LoadEvents(toParams);
      }
    )
  },
  computed: {
    ...mapGetters(['eventlist', 'date_range', 'total'])
  },
  methods: {
    CheckFilters(categorylist, filters) {
      let filtered_ids = [];
      if (categorylist.keys.length) {
        for (let key of categorylist.keys) {
          let filtered = categorylist.data[key].terms.filter((item) => filters.indexOf(item.id) >= 0);
          if (filtered.length) {
            for (let term of filtered) {
              filtered_ids.push(term.id);
            }
          }
        }
      }

      return filtered_ids;
    },
    LoadEvents(param) {
      this.setLoading(true);
      let filters = [];

      if (param && Object.keys(param).length) {
        let query_vars = param;
        let query_list = [];
        Object.keys(query_vars).forEach((key) => {
          query_list.push(query_vars[key]);
        });

        let query_params = query_list.join(",").split(",");

        if (query_params.length) {
          filters = query_params;
        }
      }

      if (!filters.length) {
        getEvents().then((eventlist) => {
          getCategories().then((categorylist) => {

            this.setEventList({eventlist: eventlist.data, total: eventlist.query.total})
            this.setCategoryList(categorylist)
            this.setLoading(false);
          }).catch(() => {
            this.setLoading(false);
          });
        }).catch(() => {
          this.setLoading(false);
        });
      } else {
        getFilteredEvents('', '', filters, 0).then((eventlist) => {
          getCategories().then( async (categorylist) => {
            this.setEventList({eventlist: eventlist.data, total: eventlist.query.total})
            await this.setCategoryList(categorylist)
            const filter = this.CheckFilters(categorylist, filters);
            if (filter.length) {
              this.setFilter(filter);
            }

            this.setLoading(false);
          }).catch(() => {
            this.setLoading(false);
          });
        }).catch(() => {
          this.setLoading(false);
        });
      }

      const start = moment().startOf("month"), end = moment().endOf("month");
      getFilteredEvents(start.format(DATE_FORMAT), end.format(DATE_FORMAT), [], 0).then((eventlist) => {
        let monthevents = [];
          for (let event of eventlist.data) {
            if (moment(event.date.start.date) > moment().endOf('month')) {
              break;
            }

            monthevents.push(moment(event.date.start.date).toDate());
          }

          this.setMonthEvents([
            generateStaticDay(monthevents, start.format(DATE_FORMAT))
          ]);
      });

    },
    ...mapActions(['setEventList', 'setClearAll', 'setLoading', 'setMonthEvents', 'setCategoryList', 'setFilter'])
  }
}

</script>
